import { importProvidersFrom } from '@angular/core';
import { Route } from '@angular/router';
import { environment } from '@awo-care/shared-auth';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';

const recaptchaProviders = [
  importProvidersFrom(RecaptchaV3Module),
  {
    provide: RECAPTCHA_V3_SITE_KEY,
    useValue: environment.recaptchaSiteKey,
  },
];

/**
 * Kündigungsschaltfläche (§ 312k BGB) und Widerrufsschaltfläche (§ 356a BGB).
 *
 * Bewusst ohne Guard: Beide Erklärungen müssen ohne Anmeldung und ständig
 * erreichbar sein. Die Zuordnung zum Vertrag übernimmt die Verwaltung, weil
 * sich ein nicht angemeldeter Absender technisch nicht identifizieren lässt.
 */
export const CONTRACT_DECLARATION_ROUTES: Route[] = [
  {
    path: 'kuendigen',
    loadComponent: () =>
      import('./contract-declaration.component').then(
        (mod) => mod.ContractDeclarationComponent
      ),
    providers: recaptchaProviders,
    data: {
      declarationType: 'cancellation',
      title: $localize`:@@seo.cancellation.title:Vertrag kündigen`,
    },
  },
  {
    path: 'widerruf',
    loadComponent: () =>
      import('./contract-declaration.component').then(
        (mod) => mod.ContractDeclarationComponent
      ),
    providers: recaptchaProviders,
    data: {
      declarationType: 'withdrawal',
      title: $localize`:@@seo.withdrawal.title:Vertrag widerrufen`,
    },
  },
];
